var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "update-resource-in-zip" }, [_c('el-button', _vm._b({ on: { "click": _vm.open } }, 'el-button', _vm.innerButtonAttrs, false), [_c('i', { staticClass: "el-icon-refresh" })])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };